export const derogationsQueryKeys = {
	all: ["derogations"] as const,
	offerHasDerogation: (constructionSiteId: number, binderWarrantyId: number) =>
		[
			...derogationsQueryKeys.all,
			"offer-has-derogation",
			constructionSiteId,
			binderWarrantyId,
		] as const,
};
